const Tags = require("components/abstract/Tags");

class SubjectTags extends Tags {

	render() {
		return (
			<div className={this.className} {...this.inputProps}>{this.renderTags()}</div>
		);
	}

}

module.exports = SubjectTags;


// WEBPACK FOOTER //
// ./resources/js/components/widgets/SubjectTags.js